const handleConvert=( data )=>( 
    new Promise((resolve, reject)=>{
        const arrNew_ = data.map(el=>{
            const objeto = {};
            for(const x in el){
                const el2 = el[x];
                objeto[el2.field] = el2.value;
            }
            return objeto;
        })
        resolve(arrNew_);
    }).then(( arrNew)=>{
        return arrNew;
    }).catch((err)=>{
        return ({Error:err});
    })
);

export default handleConvert;